import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useHoldedIntegracion() {
  const { perfil } = useAuth();
  const empresaId = perfil?.empresa_id;
  const qc = useQueryClient();

  const q = useQuery({
    queryKey: ['holded-integracion', empresaId],
    enabled: !!empresaId,
    queryFn: async () => {
      const { data } = await supabase
        .from('holded_integraciones')
        .select('empresa_id, activa, ultima_importacion, updated_at, webhook_activo, crear_ot_desde_presupuesto')
        .eq('empresa_id', empresaId!)
        .maybeSingle();
      return data;
    },
    staleTime: 60_000,
  });

  return {
    activa: !!q.data?.activa,
    integracion: q.data,
    cargando: q.isLoading,
    refrescar: () => qc.invalidateQueries({ queryKey: ['holded-integracion', empresaId] }),
  };
}

export function useHoldedSyncPendientes() {
  const { perfil } = useAuth();
  const { activa } = useHoldedIntegracion();
  const empresaId = perfil?.empresa_id;

  return useQuery({
    queryKey: ['holded-pendientes', empresaId],
    enabled: !!empresaId && activa,
    queryFn: async () => {
      const { data } = await supabase
        .from('clientes')
        .select('id, holded_contact_id, holded_sync_estado, activo')
        .eq('empresa_id', empresaId!)
        .eq('activo', true);
      let errores = 0, pendientes = 0, ok = 0;
      for (const c of data || []) {
        if (c.holded_sync_estado === 'error') errores++;
        else if (!c.holded_contact_id || c.holded_sync_estado === 'pendiente') pendientes++;
        else if (c.holded_sync_estado === 'ok') ok++;
      }
      return { errores, pendientes, ok, total: data?.length || 0 };
    },
    staleTime: 30_000,
  });
}
